import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ObservableManager } from './observableManager.type';

@Component({
  selector: 'app-mu-base',
  template: '<div></div>',
})
export abstract class MuComponent implements OnInit, OnDestroy {
  private observableManager = new ObservableManager();

  ngOnDestroy(): void {
    this.observableManager.release();
    this.muOnDestroy();
  }

  ngOnInit(): void {
    this.muOnInit();
  }

  watch<T>(observable: Observable<T>): Observable<T> {
    return this.observableManager.watch(observable);
  }

  abstract muOnDestroy(): void;

  abstract muOnInit(): void;
}
